/**
 * Shared pack badge helpers for all pack-bundle*.js (product-pack).
 * Keeps .items-badges (Sale / Selling Out / etc.) in sync with the currently
 * selected pack, mirroring assets/product-images-slider.js buildBadgesHTML.
 */
(function (window) {
  'use strict';

  /**
   * Reads the dummy pack product (handle/title/tags/price/etc.) rendered next
   * to a checked color-set input in snippets/color-set-wrapper.liquid.
   */
  function getDummyProductFromColor(color) {
    const dummyJsonData = color?.nextElementSibling?.querySelector(".dummy-json-data");
    if (!dummyJsonData) return null;
    try {
      return JSON.parse(dummyJsonData.innerHTML);
    } catch (err) {
      return null;
    }
  }

  /**
   * Only overwrites the badge once we've confirmed the new product actually
   * carries a `tags` array — if the dummy JSON failed to load/parse, we leave
   * whatever badge is currently shown instead of blanking it out on bad data.
   */
  function updateItemsBadges(ctx, product) {
    if (!product || !Array.isArray(product.tags)) return;
    if (!ctx.imagesSlider || typeof ctx.imagesSlider.buildBadgesHTML !== "function") return;
    const badgesContainer = document.querySelector(".items-badges");
    if (!badgesContainer) return;
    badgesContainer.innerHTML = ctx.imagesSlider.buildBadgesHTML(product);
  }

  window.PackBadges = {
    getDummyProductFromColor: getDummyProductFromColor,
    updateItemsBadges: updateItemsBadges,
  };
})(window);
